import { render } from "./HeroiconsOutlinePlay.vue?vue&type=template&id=46e89226"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePlay.vue"]])

export default __exports__